<template>

  <div>
    <div class="box-company-logo" v-if="object.logo">
      <img :src="object.logo" onerror="this.src='https://placeimg.com/100/100/tech'" class="logo">
    </div>
    <div class="box-company-logo" v-else>
      <img src="/static/svg/icon_clarity-building.svg" class="icon icon-svg">
    </div>
  </div>

</template>

<script>

export default {
  name: 'CompanyLogo',
  props: ['object'],
  data () {
    return {
    }
  }
}

</script>

<style lang="scss" scoped>

.box-company-logo {
  $size: 100px;

  display: block;
  width: $size;
  height: $size;
  border-radius: 6px;
  background-color: $midnight-blue;

  .icon {
    margin: 1.5rem .5rem 0;
  }

  .icon-svg {
    $s: 60px;

    width: $s;
    height: $s;
  }

  .logo {
    border: 1px solid $midnight-blue
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CompanyLogo.vue